module.exports = __webpack_public_path__ + "img/電気回路_6_10_1.952efe16.png";